import React, { FC, useState } from 'react';

import { getLegalDocsData } from '@/api/get-legal-docs-data';
import useAsyncEffect from '@/hooks/use-async-effect';
import { DocData, DocsLinks, DocumentName } from '@/types/legal';

import { Footer } from '../Footer/Footer';

import { HeaderSection } from './HeaderSection/HeaderSection';
import { ImportantDocuments } from './ImportantDocuments/ImportantDocuments';
import { RussianSoftwareInfo } from './RussianSoftwareInfo/RussianSoftwareInfo';
import { SupportServiceSection } from './SupportServiceSection/SupportServiceSection';
import { TrainingVideosSection } from './TrainingVideosSection/TrainingVideosSection';

import styles from './HelpCenterContainer.module.scss';

export const HelpCenterContainer: FC = () => {
	const [documents, setDocuments] = useState<DocData[]>([]);
	const [softwareInfoDocuments, setSowtwareInfoDocuments] = useState<DocData[]>([]);
	const [documentsLinks, setDocumentsLinks] = useState<DocsLinks>();

	useAsyncEffect(async () => {
		const viewDocumentCode = [
			'mfp_policy',
			'term_of_use',
			'user_agreement',
			'tech_stack',
			'fishplace_user_manual',
			'fishplace_functional_features',
			'fishplace_setup',
			'fishplace_lifecycle',
		];
		const softWareDocs = ['28219', '2024683715'];
		const docs = await getLegalDocsData();

		const filteredDocs = docs.filter((doc) => viewDocumentCode.includes(doc.title_en));
		setDocuments(filteredDocs);

		const softwareInfoFilteredDocs = docs.filter((doc) => softWareDocs.includes(doc.title_en));
		setSowtwareInfoDocuments(softwareInfoFilteredDocs);

		setDocumentsLinks(
			docs.reduce((acc, doc) => {
				acc[DocumentName[doc.title_en]] = doc.file ?? '';
				return acc;
			}, {} as DocsLinks),
		);
	}, []);

	return (
		<div className={styles.container}>
			<HeaderSection />
			<TrainingVideosSection />
			<RussianSoftwareInfo documents={softwareInfoDocuments} />
			<ImportantDocuments documents={documents} />
			{/* {<section className={styles.guidesSection}>
							<h2 className={styles.subtitle}>{t('Руководства и статьи')}</h2>
							<div className={styles.documentsList}>
								{documents.map((doc) => (
									<DocumentCard
										key={doc.title}
										title={doc.title}
										description={docsDescription[doc.id]}
									/>
								))}
							</div>
						</section>
			} */}
			<SupportServiceSection />
			<Footer docs={documentsLinks} />
		</div>
	);
};
